import React from 'react';
import PropTypes from 'prop-types';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { useTheme } from '@mui/material/styles';

const getOptions = (seriesData, yAxisTitle, theme) => ({
  chart: {
    type: 'column',
    backgroundColor: theme.palette.background.default,
  },
  title: {
    text: '',
  },
  yAxis: {
    allowDecimals: false,
    min: 0,
    title: {
      text: yAxisTitle,
    },
  },
  xAxis: {
    categories: seriesData && seriesData.categories ? seriesData.categories : [],
    crosshair: true,
  },
  credits: {
    enabled: false,
  },
  series: seriesData && seriesData.series ? seriesData.series : [],
});

const BasicColumnGraphV2 = ({ seriesData, yAxisTitle }) => {
  const theme = useTheme();
  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={getOptions(seriesData, yAxisTitle, theme)}
    />
  );
};

BasicColumnGraphV2.propTypes = {
  seriesData: PropTypes.object.isRequired,
  yAxisTitle: PropTypes.string,
};

BasicColumnGraphV2.defaultProps = {
  yAxisTitle: undefined,
};

export default BasicColumnGraphV2;
